import { APIAdress } from "./APIAdress";
import { PHPResponse } from "../../../../library-js/php/PHPResponse";
import { InputData } from "../../../../library-js/php/input/InputData";
import { PHPRequest } from "../../../../library-js/php/PHPRequest";
import { RandomUIDGenerator } from "../../../../library-js/random/RandomUIDGenerator"; 
import { ElementAttribute } from "../../../../library-js/dom-tools/ElementAttribute";
import { ElementType } from "../../../../library-js/dom-tools/ElementType";
import { Rokojori } from "../../Rokojori";

interface APICallClass
{
  ADRESS:APIAdress;
  addListener( element:Element, selectors:string[] ):void;
}

export abstract class APICall<I extends InputData, R extends PHPResponse> extends PHPRequest<APIAdress,I,R>
{
  static readonly apiDataType = new ElementType( "api-data" ); 
  
  private _elementAttribute:ElementAttribute;

  get attribute()
  {
    if ( this._elementAttribute )
    {
      return this._elementAttribute;
    }

    this._elementAttribute = APICall.createElementAttribute( this._adress );
    return this._elementAttribute;
  }

  static createElementAttribute( adress:string )
  {
    return new ElementAttribute( "api-" + adress );
  }

  static getValue( selector:string, target:Element|Document = undefined ):string
  {
    target = target || document;

    let element = target.querySelector( selector );

    if ( element === null )
    {
      return null;
    }

    if ( APICall.apiDataType.is( element ) )
    {
      return element.textContent;
    }
    else if ( ElementType.input.is( element ) )
    {
      return ( element as HTMLInputElement ).value;
    }
         
    return null;
    
  }

  static applyListener( apiCall:APICallClass )
  {
    console.log( "add listener", apiCall );
    let attribute = APICall.createElementAttribute( apiCall.ADRESS );
    let elements = document.querySelectorAll( attribute.selector );
    
    for ( let i = 0; i < elements.length; i++ )
    { 
      let element = elements[ i ];
      let selectors = attribute.from( element ).split( "," );
      apiCall.addListener( element, selectors );
      attribute.removeFrom( element );   
    }

  } 

}